var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{staticClass:"code"},[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_vm._v(_vm._s(_vm.title))]),_c('v-expansion-panel-content',[_c('v-card',[_c('v-card-text',[(_vm.code)?[_c('pre',[_c('code',{staticClass:"code"},[_vm._v(_vm._s(_vm.bodyCopy))])])]:[_vm._v(_vm._s(_vm.bodyCopy))]],2)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }